// The background plugin
import background, { ModeEnum } from '@react-page/plugins-background';
// import css as well. currently, we caannot do this here in the demo project and have moved that to _app.tsx
// see https://github.com/vercel/next.js/issues/19717
// import '@react-page/plugins-background/lib/index.css';
// The divider plugin
import divider from '@react-page/plugins-divider';
// The html5-video plugin
import html5video from '@react-page/plugins-html5-video';
// import '@react-page/plugins-html5-video/lib/index.css';
// The image plugin
import { imagePlugin } from '@react-page/plugins-image';
// import '@react-page/plugins-image/lib/index.css';
// The spacer plugin
import spacer from '@react-page/plugins-spacer';
// import '@react-page/plugins-spacer/lib/index.css';
// The video plugin
import video from '@react-page/plugins-video';
// import '@react-page/plugins-video/lib/index.css';
import { migeranWebSlate } from './slate';
import codeSnippet from './codeSnippet';
import buttonPlugin from '@migeran/plugins-button';
import formLayout from '@migeran/plugins-formlayout';
import reusable from '@migeran/plugins-reusable';
import list from '@migeran/plugins-list';
import sabeeApp from "@migeran/plugins-sabeeapp-booking";
import simpleText from "@migeran/plugins-simple-text";
// Define which plugins we want to use.
export default function createCellPlugins(props) {
    let doc_name = "";
    if (props.data && props.data.form_name) {
        doc_name = props.data.form_name;
    }
    const cellPlugins = [
        simpleText,
        // defaultSlate,
        migeranWebSlate,
        spacer,
        imagePlugin({ imageUploader: props.imageUploader }),
        video,
        divider,
        html5video,
        codeSnippet,
        background({
            imageUploader: props.imageUploader,
            enabledModes: ModeEnum.COLOR_MODE_FLAG |
                ModeEnum.IMAGE_MODE_FLAG |
                ModeEnum.GRADIENT_MODE_FLAG,
        }),
        buttonPlugin({ imageUploader: props.imageUploader, defaultHoverTextColor: props.data.page_layout_data.item_hover_text_color }),
        sabeeApp
    ];
    if (props.data && props.data.allowed_doctypes) {
        props.data.allowed_doctypes.map((doc) => {
            let formPlugin = formLayout({ form: doc.form,
                imageUploader: props.imageUploader,
                defaultHoverTextColor: props.data.page_layout_data.item_hover_text_color });
            cellPlugins.push(formPlugin);
        });
    }
    ;
    if (props.data && props.data.reusable_components) {
        props.data.reusable_components.map((page) => {
            let plugin = reusable({ id: page.name, name: page.title, value: JSON.parse(page.data) });
            cellPlugins.push(plugin);
        });
    }
    ;
    if (props.data && props.data.blogs) {
        let plugin = list({ listItems: props.data.blogs });
        cellPlugins.push(plugin);
    }
    ;
    return cellPlugins;
}
//# sourceMappingURL=cellPlugins.js.map